import { createContext, useContext, useState, useCallback } from 'react';

interface RemoteSessionContextType {
  isBeingMonitored: boolean;
  setIsBeingMonitored: (v: boolean) => void;
  endSession: (() => void) | null;
  registerEndSession: (fn: (() => void) | null) => void;
}

const RemoteSessionContext = createContext<RemoteSessionContextType | undefined>(undefined);

export function useRemoteSession() {
  const ctx = useContext(RemoteSessionContext);
  if (!ctx) {
    throw new Error('useRemoteSession must be used within RemoteSessionProvider');
  }
  return ctx;
}

export function useRemoteSessionSafe() {
  return useContext(RemoteSessionContext);
}

export function RemoteSessionProvider({ children }: { children: React.ReactNode }) {
  const [isBeingMonitored, setIsBeingMonitored] = useState(false);
  const [endSession, setEndSession] = useState<(() => void) | null>(null);

  const registerEndSession = useCallback((fn: (() => void) | null) => {
    setEndSession(() => fn);
  }, []);

  return (
    <RemoteSessionContext.Provider value={{ isBeingMonitored, setIsBeingMonitored, endSession, registerEndSession }}>
      {children}
    </RemoteSessionContext.Provider>
  );
}
